/* eslint-disable import/order */
/* eslint-disable arrow-body-style */
import React from "react";

import Login from "./Login";

const DefaultLogin = () => {
    const navigateUrl = "/home";

    return <Login navigateUrl={navigateUrl} />;
};

export default DefaultLogin;
